namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_iframe, {

		background: {
			color: $mol_theme.card,
		},
		
		Blocker: {
			position: 'absolute',
			height: '100%',
			width: '100%',
			zIndex: 2,
		},

		Iframe: {
			maxHeight: 'none',
			width: '100%',
			padding: 0,
			border: {
				radius: 0,
			},
			colorScheme: 'auto',
			touchAction: 'none',
		},

		Run: {
			width: '100%',
			height: '100%',
			minHeight: '100%',
			flex: {
				grow: 1,
			},
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
			padding: 0,
			border: {
				radius: 0,
			},
			background: {
				color: $mol_theme.shade,
			},
			color: $mol_theme.text,
			opacity: 0.3,
		},

		Run_icon: {
			width: '5rem',
			height: '5rem',
		},

		// Iframe_title: {
		// 	textOverflow: 'ellipsis',
		// 	whiteSpace: 'nowrap',
		// 	overflow: 'hidden',
		// 	display: 'block',
		// },

		Tg_post_dom: {
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
